// extracted by mini-css-extract-plugin
export var bcActive = "breadcrumbs-module--bc-active--4ba3d";
export var breadcrumbs = "breadcrumbs-module--breadcrumbs--2f134";